var map = {
	"./0-ai.png": 12512,
	"./1-element-turine.PNG": 87502,
	"./2-normal-and-blind-cat.JPG": 13855,
	"./3-pet-economy.JPG": 9262,
	"./4-exihibition-1.JPG": 29147,
	"./5-exihibition-2.JPG": 35173,
	"./6-timeline.png": 71505,
	"./7-science.1987.largecover.png": 98248,
	"./IMG_7126.JPG": 7688,
	"./IMG_7127.JPG": 19365,
	"./IMG_7128.JPG": 82294,
	"./IMG_7129.JPG": 35155,
	"./IMG_7130.JPG": 64181
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16712;